const swrConfig = {
    revalidateOnFocus: false
};

export default swrConfig;
